import { useSelector } from 'react-redux';
import { IState } from 'redux/reducers';
import { Scope } from 'redux/reducers/authReducer';

export function usePermission(scope: Scope) {
  const authState = useSelector((state: IState) => state.auth);
  const hasPermission = authState.scopes.some((i) => i === scope);
  return hasPermission;
}
